import SearchInput from "../common/SearchInput";
import { CALL_STATUS_FILTERS } from "../../utils/constants";
import { DATE_RANGE_OPTIONS } from "../../utils/dateRanges";

export const DURATION_BUCKETS = [
  { value: "", label: "All durations", duration_min: "", duration_max: "" },
  { value: "under-10", label: "<10s", duration_min: "1", duration_max: "10" },
  { value: "10-30", label: "10-30s", duration_min: "10", duration_max: "30" },
  { value: "30-60", label: "30s-1m", duration_min: "30", duration_max: "60" },
  { value: "60-180", label: "1-3m", duration_min: "60", duration_max: "180" },
  { value: "180-plus", label: "3m+", duration_min: "180", duration_max: "" },
];

export function resolveDurationBucket(value) {
  return DURATION_BUCKETS.find((bucket) => bucket.value === value) || DURATION_BUCKETS[0];
}

export default function DashboardFilterStrip({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  directionFilter,
  onDirectionFilterChange,
  dateRange,
  onDateRangeChange,
  customDateFrom,
  customDateTo,
  onCustomDateFromChange,
  onCustomDateToChange,
  durationBucket,
  onDurationBucketChange,
  lineFilter,
  onLineFilterChange,
  onClear,
}) {
  const hasFilters = Boolean(
    searchValue ||
      statusFilter ||
      directionFilter ||
      dateRange !== "30d" ||
      customDateFrom ||
      customDateTo ||
      durationBucket ||
      lineFilter,
  );

  return (
    <section className="dashboard-filter-strip" aria-label="Dashboard filters">
      <div className="dashboard-filter-search">
        <SearchInput
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search calls, names, summaries..."
        />
      </div>

      <select
        className="dashboard-filter-control"
        value={dateRange}
        onChange={(event) => onDateRangeChange(event.target.value)}
        aria-label="Date range"
      >
        {DATE_RANGE_OPTIONS.map((option) => (
          <option key={option.value || "all"} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <select
        className="dashboard-filter-control"
        value={directionFilter}
        onChange={(event) => onDirectionFilterChange(event.target.value)}
        aria-label="Direction"
      >
        <option value="">All directions</option>
        <option value="inbound">Inbound</option>
        <option value="outbound">Outbound</option>
      </select>

      <select
        className="dashboard-filter-control"
        value={statusFilter}
        onChange={(event) => onStatusFilterChange(event.target.value)}
        aria-label="Status"
      >
        {CALL_STATUS_FILTERS.map((filter) => (
          <option key={filter.value || "all"} value={filter.value}>
            {filter.label}
          </option>
        ))}
      </select>

      <select
        className="dashboard-filter-control"
        value={durationBucket}
        onChange={(event) => onDurationBucketChange(event.target.value)}
        aria-label="Duration"
      >
        {DURATION_BUCKETS.map((bucket) => (
          <option key={bucket.value || "all"} value={bucket.value}>
            {bucket.label}
          </option>
        ))}
      </select>

      <input
        className="dashboard-filter-control dashboard-filter-line"
        value={lineFilter}
        onChange={(event) => onLineFilterChange(event.target.value)}
        placeholder="Number / line"
        aria-label="Number or line"
      />

      {dateRange === "custom" ? (
        <div className="dashboard-custom-dates">
          <input
            type="date"
            className="dashboard-filter-control"
            value={customDateFrom}
            onChange={(event) => onCustomDateFromChange(event.target.value)}
            aria-label="Custom date from"
          />
          <input
            type="date"
            className="dashboard-filter-control"
            value={customDateTo}
            onChange={(event) => onCustomDateToChange(event.target.value)}
            aria-label="Custom date to"
          />
        </div>
      ) : null}

      <button
        type="button"
        className="dashboard-filter-clear"
        disabled={!hasFilters}
        onClick={onClear}
      >
        Clear
      </button>
    </section>
  );
}
